import { axiosGgs } from "../../services/axios";

const runApplication = async (app_id) => {
  console.log("Start app ID =", app_id);
  const res = await axiosGgs.post(`/apps/run`, { app_id });
  return res.data;
};

export default runApplication;
